import type { Constructor, LitMixinBase } from './mixin-types';
import { property } from 'lit/decorators.js';
import { consume } from '@lit/context';
import { ActiveShopContext } from '../contexts/active-shop-context';
import { IShopAccess } from '../api/model/login-access-token';

// Consumer mixin for any page that needs to know the active shop without owning
// it. Pages that *require* an active shop should additionally check
// `if (!this.activeShop) return router.navigate('/shop/select')`.
export const WithActiveShopConsumer = <T extends LitMixinBase>(
  superClass: T
) => {
  class WithActiveShopConsumerClass extends superClass {
    @consume({ context: ActiveShopContext, subscribe: true })
    @property({ attribute: false })
    public activeShop?: IShopAccess;
  }

  return WithActiveShopConsumerClass as Constructor<WithActiveShopConsumerInterface> &
    T;
};

export interface WithActiveShopConsumerInterface {
  activeShop?: IShopAccess;
}
